export enum PresignedURLTypesEnum {
  // Used by the back end GetPresignedUrlView endpoint to determine which file model the presigned url request applies to.
  ORGANIZATION_KEY_DOCUMENT = 'organization_key_document',
}
